import '@/plugins/vSelect';
import '@/plugins/moment';

import {
  AUTHENTICATED_EVENT,
  LOADED_EVENT,
  MISSING_REFRESH_TOKEN_EVENT,
  SESSION_TIMEOUT_EVENT,
} from '@paybis/frontend-authentication-app/src/constants';
import AuthenticationFlow from '@paybis/frontend-authentication-app/src/index';
import Vue from 'vue';

import { hideAuthLoader } from '@/helpers/hideAuthLoader';
import { i18n, i18nSetMemberLocale } from '@/i18n/index';
import Settings from '@/plugins/dateTime';
import errorHandle from '@/plugins/errorHandle';
import router from '@/route/index';
import authClient from '@/services/clients/authentication';
import store from '@/store/index';
import { AuthType } from './types';

import eventBus from '../assets/js/helpers/event-bus';
import AuthFlashMsg from './components/Auth/AuthFlashMsg';
import AuthWrapper from './components/Auth/AuthWrapper';
import UrlHelper from './helpers/UrlHelper';

Vue.use(AuthenticationFlow);

errorHandle(router);

window.addEventListener( 'pageshow', (event) => {
  if (event.persisted || (typeof window.performance !== 'undefined' && window.performance.navigation.type === 2)) {
    window.location.reload();
  }
});

new Vue({ // eslint-disable-line no-new
  el: '#login',
  components: {
    AuthFlashMsg,
    AuthWrapper,
  },
  render(h) {
    if (!this.isI18nReady) {
      return;
    }

    const dangerMessage = this.flashDanger.length > 0 ? h('auth-flash-message', {
      props: {
        msg: this.flashDanger,
        type: 'danger',
      },
      slot: 'flashMsg',
    }) : null;

    const successMessage = this.flashSuccess.length > 0 ? h('auth-flash-message', {
      props: {
        msg: this.flashSuccess,
        type: 'success',
      },
      slot: 'flashMsg',
    }) : null;

    const locale = i18n.locale;

    return h('auth-wrapper', {
      props: {
        isLoading: this.isLoading || !this.isI18nReady,
      },
    }, [
      h('authorization-flow', {
        props: {
          view: 'login',
          countryCode: this.countryCode,
          showSignupWarning: this.showSignupWarning,
          locale,
          selectedAuthType: this.selectedAuthType,
          isPasskeyLoginFeatureEnabled: this.isPasskeyLoginFeatureEnabled,
        },
        slot: 'body',
      }),
      dangerMessage,
      successMessage,
    ]);
  },
  i18n,
  store,
  router,
  data () {
    return {
      isLoading: true,
      isI18nReady: false,
      countryCode: '',
      flashDanger: '',
      flashSuccess: '',
      showSignupWarning: false,
      isPasskeyLoginFeatureEnabled: false,
    };
  },
  computed: {
    selectedAuthType() {
      const urlParams = new URLSearchParams(window.location.search);
      return urlParams.get('tab') || AuthType.PRIVATE;
    },
  },
  beforeMount () {
    const {
      lang: language,
      country: countryCode,
      redirectUrl,
      flashDanger,
      flashSuccess,
      supportedLangs,
      showSignupWarning,
      isPasskeyLoginFeatureEnabled,
    } = this.$el.dataset;

    this.showSignupWarning = Boolean(showSignupWarning);
    this.countryCode = countryCode;
    this.flashDanger = flashDanger;
    this.flashSuccess = flashSuccess;
    this.isPasskeyLoginFeatureEnabled = Boolean(isPasskeyLoginFeatureEnabled);

    this.$store.commit('language', language);
  
    eventBus.on(LOADED_EVENT, () => {
      hideAuthLoader();
      this.isLoading = false;
    });
    i18nSetMemberLocale(language).finally(() => {
      this.isI18nReady = true;
    });

    this.$moment.locale(language);
    Settings.defaultLocale = language;

    eventBus.on(AUTHENTICATED_EVENT, ({ tokens }) => {
      authClient.loginUser(tokens).then(() => {
        window.location.replace(UrlHelper.setLanguageToUrl(redirectUrl, window.userLanguage, JSON.parse(supportedLangs)));
      });
    });
    eventBus.on(MISSING_REFRESH_TOKEN_EVENT, () => {
      authClient.logoutUser();
    });
    eventBus.on(SESSION_TIMEOUT_EVENT, () => {
      authClient.logoutUser();
    });
  },
});
